module.exports = __webpack_public_path__ + "media/images/lms_integration_resource_center-eb970141dfce7385bb05dd9a34cc1fcb.gif";